import { Dispatch, SetStateAction } from 'react';
import { UseQueryResult, useQuery } from 'react-query';
import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';
import { tampleteGetRoute } from '../api/constants';

type useGetTemplatessProps = {
    searchValue?: string;
    templateId?: string | number;
    status?: number;
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useGetTemplates = ({
    templateId,
    searchValue,
    status,
    setErrorText = () => { },
}: useGetTemplatessProps) => {
    const queryString = `?${templateId ? `etemplate_id=${templateId}&` : ''}${status !== undefined ? `status=${status}&` : ''}${searchValue ? `name=${searchValue}` : ''}`.replace(/&$/, '');

    const { data: templatesList, isFetching: isLoadingTemplatesList }: UseQueryResult<any, any> = useQuery({
        queryKey: [templateList, status, searchValue],
        queryFn: () =>

            axiosInstance
                .get(tampleteGetRoute + queryString)
                .then((res) => res.data),
        onSuccess: (data) => {
            setErrorText('');
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchOnWindowFocus: false,
    });


    return {
        templatesList,
        isLoadingTemplatesList,
    };
};
